import * as standaloneServices from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices';
import * as monaco from 'monaco-editor';
import { generateSemanticDiff, IDocumentDiff, SemanticDiffResults, semanticDiffToDocumentDiff } from 'src/app/core/semantic-diff.pipeline';
import { loadMonacoWorkers } from 'src/assets/monaco/worker-loader';

class MyDiffProviderFactoryService {

	async getSemanticDiff(originalJsonText: string, modifiedJsonText: string): Promise<SemanticDiffResults> {
		return await generateSemanticDiff(JSON.parse(originalJsonText), JSON.parse(modifiedJsonText));
	}

	createDiffProvider(editor: any, options: any) {
		return {
			onDidChange: () => {},
			async computeDiff(
					originalModel: monaco.editor.ITextModel,
					modifiedModel: monaco.editor.ITextModel
			): Promise<IDocumentDiff> {

					let originalJson: unknown;
					let modifiedJson: unknown;

					try {
						originalJson = JSON.parse(originalModel.getValue());
						modifiedJson = JSON.parse(modifiedModel.getValue());
					}
					catch {
						return { changes: [], moves: [], identical: false, quitEarly: false };
					}

					const sem = await myGlobalDiffProvider.getSemanticDiff(originalModel.getValue(), modifiedModel.getValue());

					return semanticDiffToDocumentDiff(sem);
			}
		}
	}
}

export const myGlobalDiffProvider = new MyDiffProviderFactoryService();

let monacoInitialized = false;

export function initializeMonaco() {
	if (monacoInitialized) return;
	monacoInitialized = true;

	standaloneServices.StandaloneServices.initialize({
		diffProviderFactoryService: myGlobalDiffProvider,
	});

	// (self as any).MonacoEnvironment = {
	// 	getWorker: function (_moduleId: any, _label: string) {
	// 		const blob = new Blob(
	// 			[
	// 				`
	// 					// Empty worker – Monaco will fall back to main thread
	// 					self.onmessage = function() { /* do nothing */ };
	// 				`
	// 			],
	// 			{ type: 'text/javascript' }
	// 		);

	// 		return new Worker(URL.createObjectURL(blob));
	// 	}
	// };
	
	// Register the JSON language
	monaco.languages.register({ id: 'json' });
	monaco.languages.setMonarchTokensProvider('json', {
		tokenizer: {
			root: [
				[/"[^"]*"/, 'string'],
				[/\d+/, 'number'],
				[/{|}/, 'delimiter.curly'],
				[/\[|\]/, 'delimiter.square'],
				[/:/, 'delimiter.colon'],
				[/,/, 'delimiter.comma'],
				[/\b(true|false|null)\b/, 'keyword']
			]
		}
	});
	
	loadMonacoWorkers();

	// const baseHref = inject(APP_BASE_HREF);
	// (self as any).MonacoEnvironment = {
	// 	getWorker: function (_moduleId: any, label: any) {
	// 		if (label === 'json') {
	// 			// return new jsonWorker();
	// 			return new Worker(new URL('../../../assets/monaco/vs/language/json/json.worker.js', import.meta.url));
	// 		}
	// 		// return new editorWorker();
	// 		return new Worker(new URL('../../../assets/monaco/vs/editor/editor.worker.js', import.meta.url));
	// 	}
	// };

	// (self as any).MonacoEnvironment = {
	// 	getWorkerUrl: function (_moduleId: string, label: string) {
	// 		if (label === 'json') {
	// 			return 'assets/monaco/vs/language/json/json.worker.js';
	// 		}
	// 		return 'assets/monaco/vs/editor/editor.worker.js';
	// 	}
	// };
}